import React from "react";

const streakMappings = [
  { top: "10px", left: "0px", width: "90px" },
  { top: "10px", left: "100px", width: "80px" },
  { top: "10px", left: "190px", width: "30px" },
  { top: "22px", left: "0px", width: "132px" },
  { top: "22px", left: "142px", width: "48px" },
  { top: "22px", left: "200px", width: "28px" },
  { top: "34px", left: "74px", width: "160px" },
  { top: "46px", left: "110px", width: "40px" },
  { top: "46px", left: "170px", width: "54px" },
  { top: "58px", left: "90px", width: "110px" },
];

interface StreakProps {
  index: number;
} 

export default function Streak(props: StreakProps) {
  const { index } = props;
  const { top, left, width } = streakMappings[index];

  return (
    <div
      className={`absolute h-0.5`}
      style={{background: "#b35050", borderRadius: "20px", top: top, left: left, width: width}}>
    </div>
  );
}